var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3107_3214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 31.6376L7.51467 23.1522C5.83646 21.474 4.69358 19.3358 4.23057 17.008C3.76756 14.6803 4.00521 12.2675 4.91347 10.0748C5.82172 7.88205 7.35979 6.00792 9.33318 4.68935C11.3066 3.37078 13.6266 2.66699 16 2.66699C18.3734 2.66699 20.6934 3.37078 22.6668 4.68935C24.6402 6.00792 26.1783 7.88205 27.0865 10.0748C27.9948 12.2675 28.2325 14.6803 27.7694 17.008C27.3064 19.3358 26.1636 21.474 24.4853 23.1522L16 31.6376ZM22.6 21.2669C23.9052 19.9616 24.794 18.2985 25.1541 16.4881C25.5141 14.6776 25.3292 12.801 24.6228 11.0956C23.9163 9.39024 22.7201 7.93263 21.1852 6.90711C19.6504 5.88159 17.8459 5.33423 16 5.33423C14.1541 5.33423 12.3496 5.88159 10.8148 6.90711C9.27994 7.93263 8.08367 9.39024 7.37722 11.0956C6.67078 12.801 6.48589 14.6776 6.84594 16.4881C7.20599 18.2985 8.09481 19.9616 9.40001 21.2669L16 27.8669L22.6 21.2669ZM16 17.3336C15.2928 17.3336 14.6145 17.0526 14.1144 16.5525C13.6143 16.0524 13.3333 15.3741 13.3333 14.6669C13.3333 13.9596 13.6143 13.2814 14.1144 12.7813C14.6145 12.2812 15.2928 12.0002 16 12.0002C16.7072 12.0002 17.3855 12.2812 17.8856 12.7813C18.3857 13.2814 18.6667 13.9596 18.6667 14.6669C18.6667 15.3741 18.3857 16.0524 17.8856 16.5525C17.3855 17.0526 16.7072 17.3336 16 17.3336Z",
    fill: "#606060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3107_3214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.e35a8eee73e7bc1d76e5a24d416fff6e.svg";
export { ForwardRef as ReactComponent };